import { TopToolbar } from 'react-admin'

import { useToolbarContext } from './ToolbarContext'

export function Toolbar({
  customExporter = null,
  customExportButton = null,
  maxResults = 100000,
  children,
  leadingChildren = null,
  disabled = false,
  label = undefined,
  onClick = undefined,
}) {
  const ctx = useToolbarContext()

  // Store props in ref via context - no re-render cycle
  if (ctx) {
    ctx.setToolbarProps({
      customExporter,
      customExportButton,
      maxResults,
      children,
      leadingChildren,
      disabled,
      label,
      onClick,
    })
  }

  // Render an empty toolbar - the actual buttons are rendered by DatagridWithSelectAll
  return <TopToolbar sx={{ minHeight: 0, padding: '0 !important' }} />
}
